import type { HyloServices, HttpMethod, RequestOptions } from '@/model';
import { i18next } from '@/i18n';
import { normalize } from './decode';
export class CommunityAPI {
  constructor(readonly services: HyloServices, readonly guard: (path?: string) => void, readonly signal?: (path?: string) => AbortSignal) {}
  headers() { return { 'X-Hylo-Community-Markdown': '1', 'Accept-Language': i18next.language, 'X-Hylo-Capabilities': 'community.v1,community.publish-requests.v1' }; }
  async request<T>(method: HttpMethod, path: string, options: RequestOptions = {}): Promise<T> {
    this.guard(path);
    const requestSignal = this.signal ? AbortSignal.any([this.signal(path), ...(options.signal ? [options.signal] : [])]) : options.signal;
    const request = this.services.http.request<unknown>(method, path.startsWith('/v1/') ? path : `/v1/community${path}`, { ...options, capabilities: [...new Set([...(options.capabilities ?? []), 'community.v1', 'community.publish-requests.v1'])], signal: requestSignal, headers: { ...this.headers(), ...options.headers } });
    const value = await (requestSignal ? abortable(request, requestSignal) : request);
    this.guard(path); return normalize(value) as T;
  }
  get<T>(path: string, query?: RequestOptions['query'], signal?: AbortSignal) { return this.request<T>('GET', path, { query, signal }); }
}

export function abortable<T>(work: Promise<T>, signal: AbortSignal): Promise<T> {
  return new Promise((resolve, reject) => {
    const abort = () => reject(new DOMException('Session work cancelled', 'AbortError'));
    if (signal.aborted) { work.catch(() => undefined); abort(); return; }
    signal.addEventListener('abort', abort, { once: true });
    work.then(value => { signal.removeEventListener('abort', abort); resolve(value); }, error => { signal.removeEventListener('abort', abort); reject(error); });
  });
}
